// Libraries
import React, { useState } from 'react';

// Styled
import { Group, Header, Icon, ImageIcon, Item, Wrapper } from 'Components/flowChart/components/Collapse/index.style';

// Types
import { IItem, IOnChange } from 'Components/flowChart/components/Collapse/types';

interface IProps {
	items: IItem[];
	header: string;
	onChange: IOnChange;
}

const Collapse: React.FC<IProps> = (props) => {
	const { items, header, onChange } = props;
	const [expanded, setExpanded] = useState(true);

	const handleExpand = () => setExpanded(!expanded);

	const handleClickItem = (item: IItem) => onChange(item);

	return (
		<Wrapper expanded={expanded}>
			<Header onClick={handleExpand}>
				<p>{header}</p>
				<Icon className={expanded ? 'icon-antsomi-expand-less' : 'icon-antsomi-expand-more'} fontSize="20px" />
			</Header>
			<Group className={expanded ? 'expanded' : ''}>
				{expanded
					? items.map((item, index) => (
							<Item key={`${item.key}-${index}`} disabled={item.disabled} onClick={() => handleClickItem(item)}>
								{item.iconUrl ? <ImageIcon src={item.iconUrl} /> : <Icon className={item.icon} fontSize="24px" />}
								<p>{item.label}</p>
							</Item>
					  ))
					: null}
			</Group>
		</Wrapper>
	);
};

export default Collapse;
